import {Component, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-cancel-reason-popup',
    templateUrl: './cancel-reason-popup.component.html',
    styleUrls: ['./cancel-reason-popup.component.css'],
})
export class CancelReasonPopupComponent {

    selectedReason: string;
    otherReason: string;
    @Output() cancellationReason: EventEmitter<string> = new EventEmitter();
    @Output() reasonForm: EventEmitter<any> = new EventEmitter();
    cancelReasons: Array<string> = [
        'admin error booking officer',
        'admin error org/client',
        'interpreter no longer available',
        'interpreter did not arrive',
        'no reason given',
        'org/client did not arrive',
        'org/client cancelled',
        'org/client changed date/time',
        'org/client technical issues',
        'auslan connections technical issues',
        'public holiday',
        'no second interpreter available',
        'interpreter sick',
        'block cancellation',
        'other'
    ];
    constructor() {
        this.otherReason = '';
    }

    onChange() {
        if (this.selectedReason !== 'other') {
            this.cancellationReason.emit(this.selectedReason);
        } else if (this.selectedReason === 'other' && this.otherReason.length === 0) {
            this.cancellationReason.emit(this.selectedReason);
        } else {
            this.cancellationReason.emit(this.selectedReason + '-' + this.otherReason);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/cancel-reason-popup/cancel-reason-popup.component.ts